import React, {useEffect, useState} from "react";
import TransactionStyles from "../../../AgentViews/Transactions/styles";
import Modal2 from "../../../../components/common/Modal/Modal2";
import {useToasts} from "react-toast-notifications";
import restService from "../../../../services/restService";
import UpdateRate from "./UpdateRate";
import RestService from "../../../../services/restService";
import Search from "../../../../components/common/Search";
import {Pagination} from "antd";
import SkeletonElement from "../../../../components/Skeletons/SkeletonElement";
import Table2 from "../../../../components/common/Table/Table2";
import PaginationComponent from "../../../../components/common/Pagination";
import AddRateModal from "./AddRateModal";
const renderHeadData = (item, index) => {
  return <th key={index}>{item}</th>;
};

const Rates = () => {
  const {addToast} = useToasts();
  const [rateToRemove, setRateToRemove] = useState(undefined);
  const [rateToUpdate, setRateToUpdate] = useState(undefined);
  const [callback, setCallback] = useState(() => {});
  const [rates, setRates] = useState([]);
  const [pageTo, setPageTo] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [from, setFrom] = useState(0);
  const [loading, setLoading] = useState(0);
  const [showAddRateModal, setShowAddRateModal] = useState(false);
  const fetchRates = (page) => {
    setLoading(true);
    restService.RatesApi.getRates(page)
      .then(({data}) => {
        setPageTo(data?.data?.to);
        setTotalEntries(data?.data?.total);
        setRates(data?.data?.data);
        setFrom(data?.data?.from);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const searchChargesByInput = async (input) => {
    const response = await RestService.RatesApi.getRatesBySearchTerm(input);
    const rates = await response?.data?.data?.data;
    setRates(rates);
  };

  useEffect(() => {
    fetchRates();
  }, []);

  const onRateUpdate = () => {
    setRateToUpdate(undefined);
    addToast("Successfully Updated Rate", {
      appearance: "success",
      autoDismiss: true,
      autoDismissTimeout: 5000,
    });
    fetchRates();
  };

  const removeRate = () => {
    restService.RatesApi.removeRate(rateToRemove.id).then((response) => {
      addToast("Successfully Removed Rate", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      setRateToRemove(undefined);
      fetchRates();
    });
  };

  const pageChange = (page) => {
    setCurrentPage(page);
    fetchRates(page);
  };
  const renderBodyData = (item, index) => {
    return (
      <tr key={index}>
        <td className="id"> {item.id}</td>
        <td className="id"> {item.source_currency}</td>
        <td className="id"> {item.destination_currency}</td>
        <td className="id"> {item.rate}</td>
        <td className="flex">
          <button
            data-tip="Update"
            onClick={() => {
              setRateToUpdate(item);
            }}
            className="btn mr-3 border-none outline-none shadow-none focus:outline-none transaction-details"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
              />
            </svg>
          </button>
          <button
            data-tip="Remove"
            onClick={() => {
              setRateToRemove(item);
            }}
            className="btn outline-none border-none  shadow-none focus:outline-none transaction-details"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              viewBox="0 0 24 24"
              fill="#d32929"
            >
              <path
                fillRule="evenodd"
                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </td>
      </tr>
    );
  };

  return (
    <>
      <div className="content-layout intro-y flex flex-col gap-4 bg-white border rounded-md border-[#ECECEC] pt-5 mt-2">
        {/* <div className="header-layout flex justify-between">
          <div className="inline-flex">
            <Link to={`/add-rate`} className="btn btn-primary shadow-md mr-2">
              Add New Rate
            </Link>
          </div>
          <div className="page inline-flex">
            {rates && rates.length <= 0
              ? "No Rates Found"
              : `Showing ${from} to ${pageTo} of ${totalEntries} entries`}
          </div>
          <div className="inline-flex float-right">
            <Search
              placeholder={"Search Rates"}
              onChange={(e) => searchChargesByInput(e.target.value)}
            />
          </div>
        </div> */}

        <div className="header-layout px-5 flex items-center justify-between sm:flex-row flex-col gap-2">
          <div className="flex md:items-center w-full gap-2 md:flex-row flex-col ">
            <Search
              placeholder={"Search "}
              onChange={(e) => searchChargesByInput(e.target.value)}
            />
          </div>

          <div className=" flex flex-col-reverse w-full justify-end sm:flex-row md:items-center">
            <button
              onClick={() => setShowAddRateModal(true)}
              className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border-none bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:from-blue-700 hover:to-indigo-700 shadow-lg flex items-center gap-2"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M8 12h8" />
                <path d="M12 8v8" />
              </svg>
              <span>Add New Rate</span>
            </button>
          </div>
        </div>

        <TransactionStyles>
          {/* <div className="table-container">
            <Table
              headData={rateList.head}
              renderHead={(item, index) => renderHeadData(item, index)}
              bodyData={rates}
              renderBody={(item, index) => renderBodyData(item, index)}
            />
            <div className="mt-3 float-right">
              <Pagination
                current={currentPage}
                defaultCurrent={currentPage}
                showSizeChanger={false}
                onChange={pageChange}
                total={totalEntries}
              />
            </div>
          </div> */}

          <div className="header-layout gap-2">
            {!loading ? (
              <div className="flex w-full flex-col">
                <Table2
                  // headData={head}
                  tHead={
                    <>
                      <th className="">ID</th>
                      <th className="">Agency</th>
                      <th className="">Agent</th>
                      <th className="">Source Currency</th>
                      <th className="">Destination Currency</th>
                      <th className="">Rate</th>
                      <th className="">Action</th>
                    </>
                  }
                  // renderHead={(item, index) => renderHeadData(item, index)}
                >
                  {rates.map((item, index) => (
                    <tr key={index} className=" text-[#616161] font-normal">
                      <td>
                        <p className="">{item.id}</p>
                      </td>
                      <td>
                        <p className="">{item.agency?.name}</p>
                      </td>
                      <td>
                        <p className="">{item.agent ? `${item.agent?.firstname} ${item.agent?.lastname}` : ''}</p>
                      </td>
                      <td>
                        <p className="">{item.source_currency}</p>
                      </td>
                      <td>
                        <p className="">{item.destination_currency}</p>
                      </td>
                      <td>
                        <p className="">{item.rate}</p>
                      </td>
                      <td>
                        <div className="flex items-center gap-3">
                          <button
                            data-tip="Update Rate"
                            onClick={() => {
                              setRateToUpdate(item);
                            }}
                            className="p-2 rounded-lg transition-all border-none cursor-pointer shadow-sm hover:shadow-md bg-blue-50 text-blue-600 hover:bg-blue-100"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                              <path d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                            </svg>
                          </button>
                          <button
                            data-tip="Delete Rate"
                            onClick={() => {
                              setRateToRemove(item);
                            }}
                            className="p-2 rounded-lg transition-all border-none cursor-pointer shadow-sm hover:shadow-md bg-red-50 text-red-600 hover:bg-red-100"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M3 6h18" />
                              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                              <line x1="10" y1="11" x2="10" y2="17" />
                              <line x1="14" y1="11" x2="14" y2="17" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </Table2>
              </div>
            ) : (
              <div className="flex w-full flex-col">
                <Table2
                  tHead={
                    <>
                      <th className="">ID</th>
                      <th className="">Agency</th>
                      <th className="">Agent</th>
                      <th className="">Source Currency</th>
                      <th className="">Destination Currency</th>
                      <th className="">Rate</th>
                      <th className="">Action</th>
                    </>
                  }
                  // renderHead={(item, index) => renderHeadData(item, index)}
                >
                  {Array(10)
                    .fill()
                    .map((item, index) => (
                      <tr key={index}>
                        {Array(7)
                          .fill()
                          .map((x, i) => (
                            <td key={i}>
                              <SkeletonElement type={"title"} />
                            </td>
                          ))}
                      </tr>
                    ))}
                </Table2>
              </div>
            )}
          </div>
        </TransactionStyles>
      </div>

      <div className="flex flex-col mb-[10vh] px-5 gap-4 justify-between md:items-center md:flex-row mt-8">
        <div className="page text-[#999999] text-xs">
          {loading
            ? ""
            : rates && rates.length <= 0
            ? "No Transactions Found"
            : `Showing  ${pageTo} out of ${totalEntries} results`}
        </div>

        <div className="mt-3  flex justify-end float-right">
          <PaginationComponent
            current={currentPage}
            defaultCurrent={currentPage}
            showSizeChanger={false}
            onChange={pageChange}
            total={totalEntries}
          />
        </div>
      </div>

      {rateToRemove && (
        <Modal2
          size="medium"
          onHide={() => {
            setRateToRemove(undefined);
          }}
        >
          <div className="flex flex-col items-center gap-6 justify-center py-8 px-8">
            {/* Modern Warning Icon */}
            <div className="p-4 bg-red-100 rounded-full">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-red-600">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <path d="M12 17h.01" />
              </svg>
            </div>

            <div className="flex items-center flex-col gap-3 justify-center w-full text-center">
              <h1 className="text-2xl font-bold text-gray-900">
                Delete Exchange Rate?
              </h1>

              <p className="text-sm text-gray-600 max-w-md">
                Are you sure you want to delete this exchange rate? This action cannot be undone and will permanently remove the rate configuration.
              </p>
            </div>

            <div className="flex items-center gap-4 mt-4">
              <button
                onClick={() => setRateToRemove(undefined)}
                className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 shadow-md"
              >
                Cancel
              </button>
              <button
                onClick={() => removeRate()}
                className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border-none bg-gradient-to-r from-red-600 to-red-700 text-white hover:from-red-700 hover:to-red-800 shadow-lg flex items-center gap-2"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 6h18" />
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                </svg>
                Delete Rate
              </button>
            </div>
          </div>
        </Modal2>
      )}

      {rateToUpdate && (
        <Modal2
          size={"lg"}
          // onClick={callback}
          // modalTitle="Update Rate"
          // buttonTitle="Update Rate"
          // buttonColor="bg-blue-600"

          onHide={() => {
            setRateToUpdate(undefined);
          }}
        >
          <UpdateRate
            rate={rateToUpdate}
            initCallback={(callbackFunc) => setCallback(() => callbackFunc)}
            onSubmit={onRateUpdate}
            setRateToUpdate={setRateToUpdate}
          />
        </Modal2>
      )}

      {showAddRateModal && <AddRateModal setShow={setShowAddRateModal} />}
    </>
  );
};
export default Rates;
